<div class="dialog-wrap">
  <span class="material-symbols-outlined warning-icon"> warning </span>
  <h3>{{"GENIUS_SETTINGS.SUBSCRIPTIONS_ERROR.HEADING" | translate}}</h3>
  <div class="subscriptions-list">
    <h3>{{"SHOP.SUBSCRIPTIONS_LINKS" | translate}}</h3>
    <div class="subscription">
      <button mat-raised-button color="primary"
              (click)="openSubscription('month')">{{"SHOP.MONTHLY_SUBSCRIPTION" | translate}}</button>
      <button mat-raised-button color="primary"
              (click)="openSubscription('year')">{{"SHOP.YEARLY_SUBSCRIPTION" | translate}}</button>
    </div>
  </div>
  <span class="material-symbols-outlined close-dialog" (click)="closeDialog()"> close </span>
</div>
